import { Divider, Grid } from '@mui/material';
import React, { FC, ReactNode } from 'react';

type DoubleColumnContainerProps = {
  leftColumn: ReactNode;
  rightColumn: ReactNode;
  divider?: boolean;
  padding?: boolean;
  leftColumnSize?: number;
  rightColumnSize?: number;
};

export const DoubleColumnContainer: FC<DoubleColumnContainerProps> = (props) => {
  const { leftColumn, rightColumn, divider, padding, leftColumnSize = 6, rightColumnSize = 6 } = props;

  return (
    <Grid container sx={{ position: 'relative' }}>
      <Grid item xs={12} md={leftColumnSize} sx={{ p: padding ? 2 : 0 }}>
        {leftColumn}
      </Grid>
      {divider && (
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            display: { xs: 'none', md: 'block' },
            position: 'absolute',
            height: '100%',
            top: '50%',
            left: `${(leftColumnSize / 12) * 100}%`,
            transform: 'translate(-50%, -50%)',
          }}
        />
      )}
      <Grid item xs={12} md={rightColumnSize} sx={{ p: padding ? 2 : 0 }}>
        {rightColumn}
      </Grid>
    </Grid>
  );
};
